import React, { Fragment, useState } from 'react'

import { PageTitle } from '../../components/UI'

import { CreateUser, ListUser, SearchUser } from '../../components'

import { Modal } from '../../components/Modal'

import { User } from '../../interfaces/User/UserWMS'

import useUser from './useUser'

import { SnackBar } from '../../components/SnackBar/Snackbar'

interface UserPageProps {}

interface SnackbarState {
  open: boolean
  message: string
  status: 'success' | 'error' | 'warning'
  duration: number
}

export const UserPage: React.FC<UserPageProps> = () => {
  const [modalState, setModalState] = useState<{
    isOpen: boolean
    component: JSX.Element | undefined
  }>({
    isOpen: false,
    component: undefined
  })

  const {
    users,
    loading,
    getUsersWMS,
    error,
    handleChangePage,
    handleChangeRowsPerPage,
    firstEffect,
    setFirstEffect,
    pagination,
    handleReset
  } = useUser()

  React.useEffect(() => {
    if (error !== undefined) {
      setSnackbarState({
        open: true,
        message: error || '',
        status: 'error',
        duration: 3000
      })
    }
  }, [error])

  const [snackbarState, setSnackbarState] = React.useState<SnackbarState>({
    open: false,
    message: '',
    status: 'success',
    duration: 3000
  })

  const [search, setSearch] = React.useState('')

  const onCloseSnackbar = () =>
    setSnackbarState({ ...snackbarState, open: false })

  const onChangeSnackbarState = (state: SnackbarState) =>
    setSnackbarState(state)

  const handleModalState = (key: string, value: any) => {
    setModalState({ ...modalState, [key]: value })
    getUsersWMS(search, pagination.page)
  }

  const handleCreateUser = (user: any) => {
    setModalState({
      isOpen: true,
      component: (
        <CreateUser
          user={user}
          handleSnackbar={onChangeSnackbarState}
          closeModal={() => handleModalState('isOpen', false)}
        />
      )
    })
  }

  const handleEditUser = (user: User) => {
    setModalState({
      isOpen: true,
      component: (
        <CreateUser
          user={user}
          handleSnackbar={onChangeSnackbarState}
          closeModal={() => handleModalState('isOpen', false)}
        />
      )
    })
  }

  const handleGetUser = () => {
    getUsersWMS(search, pagination.page)
  }

  return (
    <Fragment>
      <PageTitle title='GESTIONAR USUARIOS' />

      <SearchUser
        handleUsers={getUsersWMS}
        search={search}
        setSearch={setSearch}
        handleReset={handleReset}
        handleCreateUser={handleCreateUser}
      />

      <ListUser
        users={users}
        loading={loading}
        handleEditUser={handleEditUser}
        handleGetUser={handleGetUser}
        setFirstEffect={setFirstEffect}
        pagination={pagination}
        firstEffect={firstEffect}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />

      <Modal
        funcClose={() => handleModalState('isOpen', false)}
        isOpen={modalState.isOpen}
        size='XS'
      >
        {modalState.component}
      </Modal>

      <SnackBar
        open={snackbarState.open}
        message={snackbarState.message}
        status={snackbarState.status}
        setOpen={onCloseSnackbar}
      />
    </Fragment>
  )
}
